import DownloadCalendarFileRequestModelBase from '../_generated/modelBases/download-calendar-file-request-model-base';

export default class DownloadCalendarFileRequestModel extends DownloadCalendarFileRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
